import { MDTApi } from './mdtapi.js';

export const fetchInventoryWishlistId = async () => {
    return await MDTApi.call('api.wishlist.cart', {
        method: 'GET',
        params: {
            cartType: 'BILLREP',
        },
    });
};

export const fetchConsumptionCart = async (cartId) => {
    if (!cartId) {
        throw new Error('Missing required parameter cartId');
    }

    return MDTApi.call(
        'api.quickOrder.addToCart',
        {
            method: 'GET',
            params: {
                encapsulateSuccessor: true,
            },
        },
        { cartId }
    );
};
